<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1 m-2">
				<div class="">
					<div v-if="loading" class="">
						Loading...
					</div>
					<div v-else-if="!Object.keys(order).length" class="">
						Nothing to Process!
					</div>
					<div v-else>
						<div class="">
							<div class="flex items-center justify-between pb-4 mb-4 border-b-2">
								<div class="">
									<h2>Forecast 2</h2>
									<h1 class="text-gray-700 text-2xl sm:text-5xl mb-5 leading-none">
										{{ forecast_code }}
									</h1>
									<h3 v-if="forecast.type == 'reticulation_cable'">
										Area:
										<div class="font-bold" v-for="name in forecast.area_names">{{ name }}</div>
									</h3>
								</div>
								<div class="text-right">
									<h1 class="text-gray-700 text-xl sm:text-3xl mb-5 uppercase inline-block px-2 py-1" :class="`${forecastStatus}Class`">
										{{ forecastStatus }}
									</h1>
									<template v-if="forecast.type == 'reticulation_cable'">
										<div class="mb-4 p-1" v-if="forecast.expected_delivery_datetime">
											<label class="block text-gray-700 text-sm mb-2" for="username">
												Expected Delivery Date
											</label>
											<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="expected_delivery_datetime" v-model="forecast.expected_delivery_datetime" type="date" placeholder="expected_delivery_datetime">
										</div>
										<div class="mb-4 p-1">
											<label class="block text-gray-700 text-sm mb-2" for="username">
												Contact on site / notes
											</label>
											<textarea rows="3" class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="extra_notes" v-model="forecast.extra_notes">
											</textarea>
										</div>
									</template>
								</div>
							</div>	
							<div class="px-6">
								<div class="flex text-sm px-2 py-1 bg-gray-600 text-gray-200 mt-6 text-center">
									<div class="flex-1 text-left">
										Product
									</div>
									<div class="w-48">
										Supplier
									</div>
									<div class="w-32">
										Order from
									</div>
									<div class="w-32">
										Qty
									</div>
									<div class="w-32">
										Price
									</div>
									<div class="w-32 text-right">
										Total
									</div>
								</div>
							
								
								<div class="">
									<div class="p-2 border-b font-bold text-sm relative text-center" :class="{'bg-red-200 text-red-800': errors[index]}" v-for="(product, index) in order">
										<div class="flex flex-wrap">
											<div class="flex-1 text-black text-left">
												<div class="ml-4">{{ product.name }} <span class="text-xs text-gray-600">{{ product.max }} </span><span class="text-xs text-gray-600" v-if="product.pack_size > 1">Pack size : {{ product.pack_size }}</span></div>
											</div>
											<div class="w-48">
												<select v-model="product.supplier_id" name="supplier" class="form-select mt-1 block ml-1 w-full" v-if="product.status=='ordered'" :ref="`supplier-${index}`" @change="changeSupplierPrice(index)">
													<!-- <template v-for="supplier in suppliers"> -->
													<template v-for="(supplier, index) in suppliers">
														<option :value="supplier.id" :key="supplier.id">{{ supplier.name }}</option>
													</template>
												</select>
											</div>
											<div class="w-32">
												<select v-model="product.company_id" name="company" class="form-select mt-1 block mx-auto" v-if="product.status=='ordered'">
													<template v-for="company in companies">
														<option :value="company.id" :key="company.id">{{ company.name }}</option>
													</template>
												</select>
											</div>
											<div class="w-32 mt-1">
												<input class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="qty" v-model="product.qty" v-if="product.status=='ordered'" @input="checkQty(index, product.count)">
											</div>
											<div class="w-32 mt-1">
												<input class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="price" v-model="product.price" @input="checkPrice(index,$event)" v-if="product.status=='ordered'">
												<div class="w-full">
													<span class="inline-block ml-1 font-light text-xs text-gray-500" v-if="product.price_date && product.status=='ordered'">{{ daysFrom(product.price_date) }}</span>
													<span class="inline-block ml-1 font-light text-xs text-blue-500 cursor-pointer" v-if="product.status=='ordered'" @click="showUpdatePricing = product">update</span>												
												</div>
											</div>
											<div class="w-32 mt-1 text-right">
												<span v-if="product.status=='ordered'">{{ (product.price && product.qty ? calculatePrice(product.qty,product.price) : 0)  | toCurrency }}</span>
											</div>									
										</div>
									</div>
								</div>
							</div>

							<div class="px-6">
								<div class="flex text-sm px-2 py-1 bg-gray-600 text-gray-200 mt-6 text-center">
									<div class="flex-1 text-left">
										Supplier
									</div>
									<div class="w-32 text-right">
										Add Transport Cost
									</div>
								</div>
								<template v-for="supplier_id in uniqueSuppliersInOrder">
									<div class="flex text-sm px-2 py-1 mt-6 text-center">
											<div class="flex-1 text-left">
												{{ getSupplierById(supplier_id).name }}
											</div>
											<div class="text-right">
												<input type="text" class="text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" @input="setTransportCost(supplier_id,$event)">
											</div>											
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
		</div>
		<div class="mt-4 bg-green-400 py-4" :class="hasError ? 'bg-green-400 cursor-not-allowed' : 'bg-green-600'" v-if="(role=='Super Admin' || role=='Administrator' || role=='Store Man') && forecastStatus=='new' && Object.keys(order).length">
			<action-button class="flex w-full justify-center text-white" @button-clicked="updateOrder" :disabled="hasError!==0">
				<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
				<span>Process Order</span>
			</action-button>
		</div>
		<portal to="modals" v-if="showUpdatePricing" :order="1">
			<update-product-pricing-modal
				:show="showUpdatePricing"
				:initial-product="showUpdatePricing"
				@close="showUpdatePricing = null"
				@reload="initData"
				>
			</update-product-pricing-modal>
		</portal>
	</div>
</template>

<script>
	import {formatDistance, parseISO} from 'date-fns';
	import UpdateProductPricingModal from '../../components/common/UpdateProductPricingModal.vue'
	export default {
		name: 'OrderProcessing',
		data () {
			return {
				forecast: {},
				order:{},
				companies:{},
				suppliers:{},
				loading: true,
				errors: [],
				shortcode:'',
				forecast_code:'',
				fcids:{},
				type:'',
				showUpdatePricing: null,
				productCategoriesToLoopThrough: [3, 4,1,2,5,6,8,10,7],
				transport_costs: []
			}
		},
		computed: {
			forecastStatus(){
				if(!this.forecast.status){
					return '';
				}
				return this.forecast.status == 'ordered' ? 'new' : this.forecast.status;
			},
			uniqueSuppliersInOrder(){
				var result = [], key;
				for (key in this.order) {
					if (this.order.hasOwnProperty(key)) {
						for (var ordernum in this.order[key]) {
							if (this.order[key].hasOwnProperty(ordernum) && ordernum === 'order') {
								if(this.order[key][ordernum].length){
									this.order[key][ordernum].forEach(split => {
										let chktype = typeof split.supplier_id;
										if(split.supplier_id && chktype === 'number')
											result.push(split.supplier_id);
									});
								}
							}
						}
					}
				}
				return result.filter((value, index, self) => {
					return self.indexOf(value) === index;
				});
			},

			role: function(){
				return this.$store.getters['auth/role'];
			},
			hasError: function(){
				let filtered = this.errors.filter(function (el) {
					return el != null;
				});
				return filtered.length;
			}
		},
		components: {
			UpdateProductPricingModal
		},
		methods: {
			pad: function(n, width, z){
				z = z || '0';
				n = n + '';
				return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
			},
			categoryByKey: function(key){
				return this.$store.getters.getProductCategoryNameById(key);
			},
			categoryKeyByIndex: function(key){
				if(key == 6){
					return 'final_fix_gen';
				}
				return this.$store.getters.getProductCategoryKeyByIndex(key);
			},
			orderProductsByCategory(catId){
				var result = {}, key;
				for (key in this.order) {
					if (this.order.hasOwnProperty(key) && this.order[key].category_id == catId) {
						result[key] = this.order[key];
					}
				}
				return result;
			},
			getSupplierById(supplier_id){
				let result =  this.suppliers.filter(supplier => {
					return supplier.id == supplier_id;
				});
				return result[0];
			},
			daysFrom: function(dateString){
				if(dateString!=null)
				{
					return formatDistance(parseISO(dateString, "yyyy-MM-dd'T'HH:mm:ssX", new Date()), new Date(), { addSuffix: true });
				}
			},
			calculatePrice: function(qty,price){
				return Number((qty*(price*100))/100)
			},
			splitProduct: function(index){
				let prodOrder = { ...this.order[index].order[this.order[index].order.length - 1]};
				let newQty = Math.floor(prodOrder.qty / 2);
				let even = prodOrder.qty % 2 == 0;
				let pack_qty = this.getPackQty(newQty,this.order[index].pack_size);
				this.order[index].order[this.order[index].order.length - 1].pack_qty = pack_qty.total;
				this.order[index].order[this.order[index].order.length - 1].pack_rem = pack_qty.rem;
				
				this.order[index].order[this.order[index].order.length - 1].qty = newQty;
				if(!even){
					newQty = newQty + 1;
				}
				prodOrder.qty = newQty;

				pack_qty = this.getPackQty(newQty,this.order[index].pack_size);
				prodOrder.pack_qty = pack_qty.total;
				prodOrder.pack_rem = pack_qty.rem;

				this.$set(this.order[index].order,this.order[index].order.length,prodOrder);
			},
			checkQty: function(index, max){
				if(Number(this.order[index].qty) !== max){
					this.$set(this.errors, index, true);
				}else{
					this.$delete(this.errors, index);
				}
			},
			checkPrice: function(index, event){
				console.log(index);
				let price = Number(event.target.value);
				if(price == NaN || price == 0){
					this.$set(this.errors, index, true);
				}else{
					this.$set(this.errors, index, undefined);
				}
			},
			setTransportCost: function(supplier_id, event)
			{
				// this.transport_costs.filter((value, index) => {
				// 	if(value.supplier_id == supplier_id)
				// 	{
				// 		this.transport_costs[index].cost = Number(event.target.value);
				// 	}
				// });
				let index = this.transport_costs.findIndex(value=> { return value.supplier_id === supplier_id });
				if(index != -1)
				{
					this.transport_costs[index].cost = Number(event.target.value);
				}
				else {
					this.transport_costs.push({'supplier_id':supplier_id,'cost':Number(event.target.value)});
				}
				// console.log(this.transport_costs);
			},
			updateOrder: function(){
				// var order = this.$store.getters['order/getOrder']
				// var placed_by = this.$store.getters['auth/userid']
				let order = this.$_.cloneDeep(this.order);
				this.errors = [];
				let totQty = 0;
				for (var productKey in order) {
					if (order.hasOwnProperty(productKey)) {
						let supplier = Number(order[productKey].supplier_id);
						let qty = Number(order[productKey].qty);
						let price = Number(order[productKey].price);
						if((qty == NaN || qty == 0) || (price == NaN || price == 0) || (supplier == 0)){
							this.$set(this.errors, productKey, true);
						}else{
							totQty += qty;
							order[productKey].price = price;
						}
					}
				}

				if(this.errors.length){
					let success = {
						title: 'Error',
						message: 'Please check suppliers, quantities and pricing',
						type: 'error'
					}
					this.$store.commit('setStatus', success)
					return;
				}
				
				let postData = {
					'products':order,
					'fcids':this.fcids,
					'type':this.type,
					'forecast_code':this.forecast_code,
					'expected_delivery_datetime':this.forecast.expected_delivery_datetime,
					'extra_notes':this.forecast.extra_notes,
					'user_id':this.$store.getters['auth/userid'],
					'transport_costs':this.transport_costs
				};
				this.$http.post(`/forecast/${this.$route.params.fcorderid}`, postData)
					.then(response => {
						this.$store.commit('order/emptyStore');	
						let success = {
							title: 'Action Successful',
							message: 'Order Processed Successfully!',
							type: 'success'
						}
						this.$store.commit('setStatus', success)		
						// this.reload()
						// this.$emit('reload')
						this.$router.push(`/forecast/${this.forecast.job.region}/orders`);
					})
					.catch(err => {
						let error = {
							title: 'Server Error',
							message: 'Please contact Roark, page is forecast order processing',
							type: 'error'
						}
						this.$store.commit('setStatus', error);
					})
			},
			changeSupplierPrice: function(index){
				let select = this.$refs[`supplier-${index}`];
				let value = select[0].value.split("-");
				let prodOrder = { ...this.order[index]};
				if(value[0]=='W'){
					console.log(prodOrder);
					prodOrder.order.length = 1;
					//then call another method to modify order and use wharehouse
					let newPrice = prodOrder.price;
					prodOrder.order[index].price = newPrice ? (newPrice) / 100 : null;
					prodOrder.order[index].price_date = null;

					if(prodOrder.warehouse_product_count < prodOrder.ordrqty){
						prodOrder.order[index].disabled = true;
						prodOrder.order[index].qty = prodOrder.warehouse_product_count;
						let rem = prodOrder.ordrqty - prodOrder.warehouse_product_count;
						let newSplit = this.$_.cloneDeep(prodOrder.order[index]);
						let pack_qty = this.getPackQty(rem,prodOrder.pack_size);
						newSplit.qty = rem;
						newSplit.pack_qty = pack_qty.total;
						newSplit.pack_rem = pack_qty.rem;
						prodOrder.order.push(newSplit);
					}else{
						prodOrder.order[index].qty = prodOrder.ordrqty;
					}
					this.$set(this.errors, index, undefined);
					this.$set(this.order, index, prodOrder);
				}
				else 
				{
					delete prodOrder.disabled;
					let product = this.forecast.products.filter((prod) => prod.id == prodOrder.id)[0];
					let newPrice = product.pricing[prodOrder.supplier_id] ? product.pricing[prodOrder.supplier_id].price : null;
					let newPriceDate = product.pricing[prodOrder.supplier_id] ? product.pricing[prodOrder.supplier_id].date : null;
					prodOrder.price = newPrice ? (newPrice) / 100 : null;
					prodOrder.price_date = newPriceDate ? newPriceDate : null;
					this.$set(this.order, index, prodOrder);
					let supplier = Number(prodOrder.supplier_id);
					if(supplier == NaN || supplier == 0){
						this.$set(this.errors, index, true);
					}else{
						this.$set(this.errors, index, undefined);
					}
					
				}
			},
			getPackQty: function(qty, pack_size){
				let total = Math.ceil(qty / pack_size);
				let rem = pack_size-qty;
				if(qty > pack_size){
					total = Math.floor(qty / pack_size);
					rem = qty % pack_size;
					if(rem > 0){
						total++;
						rem = pack_size - rem;
					}
				}
				return {
					total: total,
					rem: rem
				};
			},
			initData: function(){
				this.$http.get(`forecast/${this.$route.params.fcorderid}`)
				.then(response => {
					this.$store.commit('setJobName', response.data.forecast.job.name);
					this.forecast = response.data.forecast;
					this.forecast.expected_delivery_datetime = response.data.forecast.expected_delivery_datetime.substring(0, 10);
					this.forecast.extra_notes = response.data.forecast.contact;
					this.forecast_code = response.data.forecast.reference_id;
					response.data.forecast.products.forEach(product => {
						let details = {
							...product,
							'status': product.pivot.status,
							'price_date': null,
							'price': null,
							'total_qty': product.count,
							'qty': product.count,
							'company_id': 1,
						}
						this.$set(this.order, product.id, details);
					});
					this.suppliers = response.data.suppliers;
					
					this.loading = false;
				})
				.catch(err => {
					this.error = err
				})
			}
		},
		created () {
			this.$store.commit('setJobName', null)
			this.$http.get(`companies`)
				.then(response => {
					this.companies = response.data
				})
				.catch(err => {
					this.error = err
				});
			this.$http.get(`suppliers`)
				.then(response => {
					this.suppliers = response.data
				})
				.catch(err => {
					this.error = err
				});
			
			this.initData();
		}
	}
</script>
<style lang="css" scoped>
	.newClass {
		@apply rounded-full bg-red-400 text-white;
	}
	.processingClass {
		@apply border-2 rounded-full border-red-400 text-red-400;
	}
	.problemClass {
		@apply border-2 rounded-full border-yellow-500 text-yellow-700;
	}
	.completeClass {
		@apply rounded-full bg-gray-300 text-white;
	}
</style>